import { Injectable } from '@angular/core';
import { SecurityService } from './security.service';
import { AccessPermissionsService } from "./access-permissions.service";

@Injectable({
  providedIn: 'root'
})
export class BizService {

  constructor(private securityService: SecurityService,
              private accessPermissionService: AccessPermissionsService) { }

  async UserLogin(email: string, password: string)
  {
    return this.securityService.UserLogin(email, password);
  }

  public async UserChangePassword(email: string, oldPassword: string, newPassword: string): Promise<boolean> {
    return await this.securityService.UserChangePassword(email, oldPassword, newPassword);
  }

  public async ResetPassword(email: string, language2LettersCode: string): Promise<boolean> {
    return await this.securityService.UserResetPassword(email, language2LettersCode);
  }

  UserLogout()
  {
    this.securityService.UserLogout();
  }

  public GetUserEmail() : string
  {
    return this.securityService.GetUserEmail();
  }

  public IsUserAuthenticated() : boolean
  {
    return this.securityService.IsUserAuthenticated();
  }

  public async LoadUserAccessPermissions()
  {
    if(this.IsUserAuthenticated()) {
      const result = await this.securityService.GetUserAccessPermissions();
      if(result.success)
      {
          this.accessPermissionService.UpdateAccessPermissions(result.permissionList);
      }
      else {
        // console.error('Error loading user access permissions: ' + result.errorMessage);
      }
    }
  }

}
